import { render, staticRenderFns } from "./userDetailRefundGroupOrders.vue?vue&type=template&id=22f6bfa4&scoped=true"
import script from "./userDetailRefundGroupOrders.vue?vue&type=script&lang=js"
export * from "./userDetailRefundGroupOrders.vue?vue&type=script&lang=js"
import style0 from "./userDetailRefundGroupOrders.vue?vue&type=style&index=0&id=22f6bfa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f6bfa4",
  null
  
)

export default component.exports